/* eslint-disable eqeqeq */
import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import './attendee-lobby.css';
import { formatDuration } from '../../utils/format';
import AttendeeDashboardView from '../../pages/attendee/dashboard/attendee-dashboard';
import { generateClient } from 'aws-amplify/api';
import { onMeetingStatusChange } from '../../graphql/subscriptions';
import { EventFetchSlides } from '../../services/event/attendee-event-slides';
import ZoomMtgEmbedded from '@zoom/meetingsdk/embedded';
import moment from "moment-timezone";

const client = generateClient();
const zoomClient = ZoomMtgEmbedded.createClient();
interface SdkData {
    meetingNumber: string;
    password: string;
    userName: string;
    userEmail: string;
    signature: string;
    tk?: string;
}

const LobbyPage: React.FC<{ sdkData: SdkData; eventData: any }> = ({
    sdkData,
    eventData,
}) => {
    const [isLive, setIsLive] = useState(false);
    const [loading, setLoading] = useState(true); // New loading state
    const { eventId } = useParams<{ eventId: string }>();
    const eventDuration = formatDuration(eventData.duration);
    const eventDateObject = new Date(eventData.date);
    const eventTimeZone = eventData.timeZone;
    const eventDate = moment(eventDateObject).format('dddd, MMMM Do YYYY');
    const eventTime = moment(eventDateObject).format('h:mm A z');
    const eventShotTimeZone = moment(eventDateObject).tz(eventTimeZone).format('z');

    useEffect(() => {
        if (eventData.isMeetingLive) {
            setIsLive(true);
            setLoading(false); // Meeting is live, stop loading
        } else {
            setLoading(false); // Data is fetched, stop loading
        }
    }, [eventData]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await EventFetchSlides(Number(eventId));
                if (response.isMeetingLive) {
                    setIsLive(true);
                }
                setLoading(false); // Data has been fetched, stop loading
            } catch (error) {
                console.error('Error fetching slides:', error);
                setLoading(false); // Stop loading even on error
            }
        };

        // Fetch data immediately on component mount
        fetchData();
        // Set up polling every 1 minute (60,000 ms)
        const intervalId = setInterval(fetchData, 60000);

        return () => clearInterval(intervalId);
    }, [eventId]);

    useEffect(() => {
        const subscription = client.graphql({ query: onMeetingStatusChange });
        const observer = subscription.subscribe({
            next: ({ data }) => {
                const newSlide = data.onMeetingStatusChange;
                if (newSlide && newSlide.eventid == eventId) {
                    if (newSlide.meetingstatusflag === false) {
                        // Clear session storage and reload the page
                        zoomClient.leaveMeeting();
                        sessionStorage.clear();
                        //window.location.reload();
                    } else {
                        setIsLive(true); // Set live flag to true
                    }
                }
            },
            error: (error) => console.warn('Subscription error:', error),
        });

        return () => observer.unsubscribe();
    }, [eventId]);

    // While loading, show a loader or nothing
    if (loading) {
        return <div>Loading...</div>;
    }

    // If the meeting is live, show the dashboard, otherwise show the lobby
    return (
        !isLive ? (
            <>
            <div className='white-line-wrapper'></div>
            <div className="lobby-container">
                  <div className="loader">
                    <div className="dot"></div>
                    <div className="dot"></div>
                    <div className="dot"></div>
                    <div className="dot"></div>
                </div>
                <div className="opening-time">Please wait, the session will begin shortly.</div> {/* Display the meeting date and time */}
                <div className="meeting-title">{eventData.title}</div> {/* Display the meeting title */}
                <div className="event-date-wrapper">
                    {eventDate} | {eventTime} {eventShotTimeZone} {/* Display the formatted event date and time */}
                </div>
                <div className="meeting-duration">Duration: {eventDuration}</div> {/* Display the meeting duration */}
            </div>
            <div className='white-line-wrapper'></div>
            </>
        ) : (
            <AttendeeDashboardView sdkData={sdkData} eventData={eventData} />
        )
    );
};

export default LobbyPage; 